(function (app, ng) {

    app.config(["$stateProvider", function ($stateProvider) {
        $stateProvider.state("Transaction.Application.Prefill",
            {
                url: "/Prefill",
                component: "prefill",
                resolve: {
                    transactionRelationships: ["transactionRelationshipApi", "$stateParams", function (transactionRelationshipApi, $stateParams) {
                        return transactionRelationshipApi.getTransactionRelationships($stateParams.transactionId);
                    }],
                    prefillCategories: ["prefillCategories", function (prefillCategories) {
                        return prefillCategories;
                    }],
                    transactionPrefills: ["transactionPrefillApi", "$stateParams", function (transactionPrefillApi,
                        $stateParams) {
                        return transactionPrefillApi.getPrefillsForTransaction($stateParams.transactionId);
                    }],
                    prevStage: ["transaction", function (transaction) {
                        if (transaction.DeterminePoints.includes("DetermineDocuments"))
                            return "Transaction.Determine.Documents";
                        else
                            return "Transaction.Determine.ProductShelf";
                    }],
                    nextStage: ["transaction", "fillableFormApi", function (transaction, fillableFormApi) {
                        return fillableFormApi.getTransactionForms(transaction.Id).then(function (response) {
                            return response.length > 0
                                ? "Transaction.Application.OptionalForms"
                                : "Transaction.Application.Launch";
                        });
                    }],
                    transaction: [
                        "transactionApi", "$stateParams", function (transactionApi, $stateParams) {
                            return transactionApi.get($stateParams.transactionId);
                        }
                    ]
                },
                onEnter: ["transaction", "transactionApi", function (transaction, transactionApi) {
                    transaction.LastTransactionStage = "Prefill";
                    transactionApi.updateLastTransactionStage(transaction.Id, transaction);
                }]
            });
    }]);

    app.component("prefill",
        {
            templateUrl: "/App/Transaction/Application/Prefill/template.html",
            controller: prefillController,
            bindings: {
                transactionRelationships: "<",
                prefillCategories: "<",
                transactionPrefills: "<",
                prevStage: "<",
                nextStage: "<",
                transaction: "<"
            }
        });

    prefillController.$inject = ["$scope", "$state", "transactionRelationshipApi", "transactionPrefillApi", "$mdDialog", "firelightSsoApi", "transactionApi", "$q", "_"];

    function prefillController($scope, $state, transactionRelationshipApi, transactionPrefillApi, $mdDialog, firelightSsoApi, transactionApi, $q, _) {
        this.$state = $state;

        var $ctrl = this;
        $scope.$parent.$ctrl.getCurrentStage($state);

        ng.extend($ctrl,
            {
                next: next,
                toggleSelection: toggleSelection,
                startFirelightSso: startFirelightSso
            });

        $ctrl.headingTxt = "Nearly there! Let us help you setup your application.";
        $ctrl.instructionsTxt = "Be sure to check with the carrier to ensure the desired setup is allowed.";
        $ctrl.clarityTxt = "This does not account for different ways carriers allow policies to be set up.";
        $ctrl.annuitant = "Annuitant";

        this.$onInit = function() {
            var relIndex = 0;
            var relation = [];
            ng.forEach($ctrl.transactionRelationships, function (r) {

                relation[relIndex] = r;
                relIndex++;
            });
            ng.forEach($ctrl.prefillCategories, function (cat) {
                cat.relation = ng.copy(relation);
                if (cat.Label === "Owner") {
                    cat.relation[findWithAttr(cat.relation, "Type", "Client")].IsActive = true;
                    var newRelation = [];
                    ng.forEach(cat.relation, function (a) {
                        if (a.Type === "Client") {
                            newRelation.push(a);
                        }
                    });
                    cat.relation = newRelation;
                } else {
                    ng.forEach(cat.relation,
                        function (a) {
                            if (a.Type === "Client" && cat.Label !== "Annuitant") {
                                cat.relation.splice(cat.relation.indexOf(a), 1);
                            }
                        });
                }

            });

            if ($ctrl.transactionPrefills.length > 0) {
                ng.forEach($ctrl.transactionPrefills,
                    function (pre) {
                        var index = findWithAttr($ctrl.prefillCategories, "Value", pre.CategoryType);
                        if (index !== -1) {
                            Object.keys($ctrl.prefillCategories[index].relation).forEach(function (key) {
                                if ($ctrl.prefillCategories[index].relation[key].RelatedClientId === pre.RelatedClientId) {
                                    $ctrl.prefillCategories[index].relation[key].IsActive = true;
                                    $ctrl.prefillCategories[index].relation[key].PrefillId = pre.Id;

                                }
                            });
                        }
                    });
            }
        };

        function toggleSelection(category, selectionId) {
            ng.forEach(category.relation, function (relation) {
                if (relation.Id !== selectionId) {
                    relation.IsActive = false;
                }
            });
        }

        function findWithAttr(array, attr, value) {
            for (var i = 0; i < array.length; i += 1) {
                if (array[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        }
        function savePrefills() {
            var promises = [];
            ng.forEach($ctrl.prefillCategories, function (cat) {
                ng.forEach(cat.relation,
                    function (r) {
                        var model =
                            {
                                transactionId: r.TransactionId,
                                relationshipId: r.Id,
                                relatedClientId: r.RelatedClientId,
                                categoryType: cat.Value,
                                isActive: r.IsActive
                            }
                        if ($ctrl.transactionPrefills.length > 0) {
                            if (!r.IsActive && ($ctrl.transactionPrefills.some(function (prefill) { return prefill.Id === r.PrefillId }))) {
                                promises.push(transactionPrefillApi.DeleteTransactionPrefill(r.TransactionId, r.PrefillId));
                            } else {
                                if (r.IsActive && !($ctrl.transactionPrefills.some(function (prefill) { return prefill.Id === r.PrefillId }))) {
                                    promises.push(transactionPrefillApi.createNewTransactionPrefill(model));
                                }
                            }
                        } else {
                            if (r.IsActive) {
                                promises.push(transactionPrefillApi.createNewTransactionPrefill(model));
                            }
                        }
                    });
            });
            return $q.all(promises);
        }

        function clientFirst(obj) {
            return obj.Type === "Client" ? "" : obj.Type;
        }

        function startFirelightSso($event) {
            savePrefills();
            var leave = $mdDialog.confirm({
                title: "Are you sure you want to launch this transaction into Firelight?",
                htmlContent:
                "<p>If you choose to continue, your transaction will be compiled and you will finish this transaction in Firelight.</p> <p> Any edits to this transaction in the future will be unavailable.</p>",
                targetEvent: $event,
                ariaLabel: "Confirm submitting transaction",
                ok: "Submit",
                cancel: "Cancel",
                skipHide: true,
                clickOutsideToClose: false
            });
            $mdDialog.show(leave)
                .then(function () {
                    var w = window.open();
                    w.document.write("Loading...");
                    firelightSsoApi.InitiateFirelightSso($ctrl.transaction.Id).then(function (data) {
                        w.document.write(data);
                        w.document.forms.samlform.submit();
                        $ctrl.transaction.TransactionStatus = "SubmittedToFirelight";
                        transactionApi.updateTransactionStatus($ctrl.transaction.Id, $ctrl.transaction);
                        $state.go("Home.Dashboard");
                    }, function (error) {
                        w.document.write(" Failed.  There was an error accessing this resource.");
                    });
                });
        }

        function next() {
            savePrefills().then(function () {
                $state.go($ctrl.nextStage);
            });
        }
    }

})(window.app, window.angular);